import moment from 'moment'
import ft from '../featureToggle'

export default {
  getDispatchLogs (VueApp, rsvpId, callback) {
    VueApp.$sdk.get('/admin/rsvp/' + rsvpId + '/logs/autodispatch', {
      token: VueApp.$store.state.session.sessionToken

    }, res => {
      if (!res.error) {
        let dispatchLog = []
        let basicInfo = {}
        res.list.forEach(function (data) {
          basicInfo = {
            created: moment(data.created, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm:ss A'),
            driver: data.driver,
            status: data.status,
            message: data.message
          }
          dispatchLog.push({
            ...basicInfo
          })
        })

        VueApp.$store.commit('rsvpDetails/setDispatchLogs', dispatchLog)
      }
      callback(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/reservation-details/dispatch.js